module.exports = __webpack_public_path__ + "img/tomorrow.be5030ca.webp";